import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import ExclusiveContainer from '../components/ExclusiveContainer'

export default function N25_10_10() {
  return (
    <NoteContainer date={'10/10/2025'} version="20.10.0">
      <VStack w="full">
        <ExclusiveContainer category="ADJUSTMENTS" institutions={['fala', 'teste', 'treinamento']}>
          <ModuleContainer moduleName="ATTENDANCES">
            <VStack w="full">
              <CategoryContainer category="ADJUSTMENTS">
                <Box>
                  <TaskTitle>Retirando classificação da saúde do atendimento</TaskTitle>
                  <TaskBreadcrumb>Atendimentos</TaskBreadcrumb>
                  <TaskDescription>Retirado campos de classificação do atendimento</TaskDescription>
                </Box>
              </CategoryContainer>
            </VStack>
          </ModuleContainer>
        </ExclusiveContainer>

        <ModuleContainer moduleName="ASSESSMENTS_AND_RESEARCH">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção do filtro de locais no perfil</TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Perfil da pesquisa</TaskBreadcrumb>
                <TaskDescription>
                  Correção do filtro que mostrava somente informações associadas aos locais do usuário.
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção das permissões</TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Perfil da pesquisa</TaskBreadcrumb>
                <TaskDescription>Correção das novas permissões do perfil da pesquisa</TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="SCHEDULES">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção dos agendamentos que não aparecem na tela</TaskTitle>
                <TaskBreadcrumb>Agendas/ Perfil da agenda</TaskBreadcrumb>
                <TaskDescription>Correção dos agendamentos que não apareciam na interface</TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="CITIZEN_PROFILE">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção da lógica de campos revisados</TaskTitle>
                <TaskBreadcrumb>Pessoas unificadas/ Perfil da pessoa unificada</TaskBreadcrumb>
                <TaskDescription>
                  Correção do fluxo de revisar campos onde o valor não era preenchido ao clicar sobre ele
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
